import { defineStore } from 'pinia'
import { fetchAccountPageMeta } from '@/api/profile'

const STATE = () => ({
  currentUser: null,
  tzOptions: [],
  beginningOfWeekOptions: []
})

/**
 * Payload of the profile account page. The profile is edited on the page
 * itself, so it is never cached across entries (ROUTER.md §4): the styxie
 * payload serves the first render exactly once, every client-side entry
 * fetches fresh.
 */
export const useProfileAccountStore = defineStore('profileAccount', {
  state: () => ({ ...STATE(), hydrated: false }),
  actions: {
    initialize(data) {
      Object.keys(STATE()).forEach((key) => {
        if (data[key] !== undefined) this[key] = data[key]
      })
      this.hydrated = true
    },
    async ensurePageMeta() {
      if (this.hydrated) {
        this.hydrated = false
        return
      }

      const res = await fetchAccountPageMeta()
      this.initialize(res.data)
      this.hydrated = false
    }
  }
})
